<script>
import { includes } from 'lodash'
import { debounce } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'addingSerial',
  props: ['product'],
  data() {
    return {
      loading: false,
      productGrade: 'A',
      serials: []
    }
  },
  computed: {
    productGradeList() {
      return [
        {
          label: 'A',
          value: 'A'
        },
        {
          label: 'B',
          value: 'B'
        },
        {
          label: 'C',
          value: 'C'
        },
        {
          label: 'D',
          value: 'D'
        }
      ]
    },
    serialList() {
      if (this.product.serial_list === undefined) return []
      return this.serials.filter(
        s =>
          !includes(
            this.product.serial_list.map(s => s.serial_no),
            s.serial_no
          )
      )
    },
    addedSerialList() {
      if (this.product.serial_list === undefined) return []
      return this.product.serial_list
    }
  },
  methods: {
    ...mapActions('saleInvoiceStore', ['onSearchSerial']),
    onSearch: debounce(async function(value) {
      console.log()
      this.loading = true
      const reponse = await this.onSearchSerial({
        search: value,
        product_id: this.product.product_id,
        grade: this.productGrade
      })
      this.serials = reponse.data
      this.loading = false
    }, 500),
    addSerial(serial) {
      this.product.serial_list.push(serial)
      this.product.quantity = this.product.serial_list.length
      this.$emit('calculate')
    },
    remove(index) {
      this.product.serial_list.splice(index, 1)
      this.product.quantity = this.product.serial_list.length
      this.$emit('calculate')
    }
  }
}
</script>

<template>
  <div>
    <ts-loading-banner :loading="loading">
      <h2 class="ts-text-gray-800 ts-relative" style="width: fit-content;">
        {{ product.product_name_en }}
        <span
          class="ts-bg-red-500 ts-absolute ts-text-xs ts--mt-2 ts--mr-4 ts-text-white ts-w-6 ts-h-6 ts-flex ts-items-center ts-justify-center ts-top-0 ts-right-0 ts-rounded-full"
          >{{ product.serial_list ? product.serial_list.length : 0 }}</span
        >
      </h2>
      <h5>{{ product.barcode }}</h5>
      <hr />
      <div class="ts-overflow-y-scroll ts-mt-4">
        <div class="ts-grid ts-grid-cols-1 ts-gap-2 ts-p-1">
          <div
            v-for="(serial, index) in addedSerialList"
            :key="index"
            class=" ts-px-2 ts-py-1 ts-rounded ts-flex ts-justify-between ts-cursor-pointer hover:ts-bg-gray-200 ts-duration-200 ts-transform ts-transition-all"
            :class="{
              'ts-bg-gray-100': index % 2 == 0
            }"
          >
            <p class="ts-mb-0">{{ serial.serial_no }}</p>
            <a href="#" class="ts-text-red-500" @click.prevent="remove(index)">
              <i class="fas fa-minus"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="ts-space-y-3 ts-mt-3">
        <a-select
          v-model="productGrade"
          class="ts-w-full"
          placeholder="--select product grade---"
          :options="productGradeList"
        ></a-select>
        <a-input-search
          @search="onSearch"
          :placeholder="$t('saleInvoice.searchSerialOnly')"
        >
        </a-input-search>
      </div>

      <div class="ts-h-64 ts-overflow-y-scroll ts-mt-4">
        <div class="ts-grid ts-grid-cols-1 ts-gap-2 ts-p-1">
          <div
            v-for="(l, index) in serialList"
            :key="index"
            class=" ts-px-2 ts-py-1 ts-rounded ts-flex ts-justify-between ts-cursor-pointer hover:ts-bg-gray-200 ts-duration-200 ts-transform ts-transition-all"
            :class="{
              'ts-bg-gray-100': index % 2 == 0
            }"
          >
            <p class="ts-mb-0">{{ l.serial_no }}</p>
            <a href="#" @click.prevent="addSerial(l)">
              <i class="fas fa-plus"></i>
            </a>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
